import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import styled from "styled-components";

//Component
import { CustomButton } from "../Forms";

//Constants
import { FontFamilyBold, FontFamilyRegular } from "../../constants"

//Assets
import RoundCloseButton from "../../images/round-close-button.png";

// Define Interface
type Props = {
  className?: string;
  img?: string;
  title?: string;
  info?: string;
  cancelText?: string;
  confirmationText?: string;
  withCloseBtn?: boolean;
  cancelAction: (args?: boolean) => void;
  confirmAction: (args?: boolean) => void;
}

interface StyledCompProps {
  fontFamilyBold?: string;
  fontFamilyRegular?: string;
}

const StyledComponent = styled.div<StyledCompProps>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  position: relative;
  .backdrop{
    width: 100%;
    height: 100%;
    background-color: rgba(36, 36, 36, 0.5);
    position: absolute;
    top: 0;
    left: 0;
  }

  .confirmation-wrapper{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 428px;
    background-color: #fff;
    border-radius: 28px;
    padding: 32px;
    position: relative;
    .close-btn {
      width: 30px;
      height: 30px;
      object-fit: contain;
      position: absolute;
      top: -30px;
      right: -30px;
      cursor: pointer;
    }
    img{
      width: 80px;
      height: 80px;
      object-fit: contain;
      margin-bottom: 24px;
    }
    .title{
      font-family: ${props => props.fontFamilyBold};
      font-size: 18px;
      font-weight: bolder;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: normal;
      text-align: center;
      color: #242424;
      margin-bottom: 16px;
    }
    .btn-wrapper{
      width: 100%;
      display: flex;
      justify-content: space-between;
      .cancel-btn {
        border-radius: 34px;
        border: solid 1px #ebebeb;
        background-color: #fff;
        margin-right: 8px;
        color: #e02020;
      }
    }
  }

  @media (max-width: 576px){
    .confirmation-wrapper{
      max-width: 343px;
      .close-btn {
        width: 24px;
        height: 24px;
        top: unset;
        bottom: -35px;
        right: 45%;
      }
      .btn-wrapper{
        .cancel-btn {
          margin-right: 9px;
          font-size: 12px;
        }
      }
    }
  }
`
StyledComponent.defaultProps = {
  fontFamilyBold: FontFamilyBold,
  fontFamilyRegular: FontFamilyRegular
}


const ConfirmationComponent: FC<Props> = ({
  className,
  img,
  title,
  info,
  cancelText,
  confirmationText,
  withCloseBtn,
  cancelAction,
  confirmAction
}) => {
  return (
    <StyledComponent className={className}>
      <div className="backdrop" onClick={() => cancelAction()} />
      <div className="confirmation-wrapper">
        {withCloseBtn && <KickImage onClick={() => cancelAction()} className='close-btn' src={RoundCloseButton} alt='close-btn' />}
        {img ? <KickImage src={img} alt="confirmation image" /> : null}
        <p className="title">{title}</p>
        <p className="info">{info}</p>
        <div className="btn-wrapper">
          <CustomButton
            className="cancel-btn"
            text={cancelText}
            onClick={cancelAction}
            disabled={false}
          />
          <CustomButton
            className="confirmation-btn"
            text={confirmationText}
            onClick={confirmAction}
            disabled={false}
          />
        </div>
      </div>
    </StyledComponent>
  )
}
ConfirmationComponent.defaultProps = {
  className: "",
  img: "",
  title: "",
  info: "",
  cancelText: "",
  confirmationText: "",
  withCloseBtn: false,
  cancelAction: () => { },
  confirmAction: () => { }
}

export default ConfirmationComponent